import { ChartSkeletonVariant } from '../components/loading/ChartSkeleton';

// Which loading skeleton each dashboard chart shows, by the chart's feature name (the `feature` of its dashboard layout entry). One place, so a
// chart's card has the same skeleton from the first paint until its data arrives, whatever stage (layout loading, waiting to scroll into view,
// querying) it is in. A feature that is not listed here gets the neutral card.
export const CHART_SKELETON_BY_FEATURE: { [featureName: string]: ChartSkeletonVariant } = {
    AgedUnbilledFeesChart: 'bars',
    MattersByCountryChart: 'card',
    CurrentMattersByUSStateChart: 'card',
    CurrentMattersByAustralianStateChart: 'card',
    KpiSummaryChart: 'card',
    StaffUnbilledFees: 'bars',
    StaffUnbilledFeesByPeriod: 'bars',
    AverageBilledFeesClosedByActingChart: 'bars',
    AverageBilledFeesClosedByMatterCategoryAndTypeChart: 'bars',
    AverageBilledFeesClosedByMatterCategoryChart: 'bars',
    AverageBilledFeesClosedByMatterTypeChart: 'bars',
    AverageBilledFeesClosedByPropertyChart: 'bars',
    AverageBilledFeesClosedByResponsibleChart: 'bars',
    AverageElapsedTimeByAssigneeChart: 'bars',
    AverageElapsedTimeByTaskTypeChart: 'bars',
    AverageFeeEstimateCurrentByActingChart: 'bars',
    AverageFeeEstimateCurrentByMatterCategoryAndTypeChart: 'bars',
    AverageFeeEstimateCurrentByMatterCategoryChart: 'bars',
    AverageFeeEstimateCurrentByMatterTypeChart: 'bars',
    AverageFeeEstimateCurrentByPropertyChart: 'bars',
    AverageFeeEstimateCurrentByResponsibleChart: 'bars',
    BillableHoursRecordedVsBudgetChart: 'columns',
    BillableHoursRecordedVsBudgetSpeedometerChart: 'gauge',
    BillableTimesByStaffChart: 'bars',
    BilledFeesVsEstimateByActingChart: 'bars',
    BilledFeesVsEstimateByMatterCategoryAndTypeChart: 'bars',
    BilledFeesVsEstimateByMatterCategoryChart: 'bars',
    BilledFeesVsEstimateByMatterTypeChart: 'bars',
    BilledFeesVsEstimateByPropertyChart: 'bars',
    BilledFeesVsEstimateByResponsibleChart: 'bars',
    BilledFeesVsEstimateTotalChart: 'bars',
    BillingRealisationChart: 'bars',
    ClientBillingChart: 'bars',
    ClientExposureChart: 'bars',
    ClosedMattersByFeeEarnerChart: 'bars',
    ClosedMattersChart: 'columns',
    CollectionRateChart: 'bars',
    CombinedNewMatterLeadsByCategoryChart: 'bars',
    CombinedNewMattersByCategoryChart: 'bars',
    ContactActivitiesByStaff: 'bars',
    ContactActivitiesBySubject: 'bars',
    CostAgreementChart: 'bars',
    CumulativeBillableHoursVsBudgetChart: 'columns',
    DebtOwingByActingChart: 'bars',
    DebtOwingByClientChart: 'bars',
    DebtOwingByMatterCategoryAndTypeChart: 'bars',
    DebtOwingByMatterCategoryChart: 'bars',
    DebtOwingByMatterTypeChart: 'bars',
    DebtOwingByPropertyChart: 'bars',
    DebtOwingByResponsibleChart: 'bars',
    DebtorDaysByMatterCategoryChart: 'bars',
    DebtorDaysByMatterTypeChart: 'bars',
    DebtorDaysByPersonActingChart: 'bars',
    DebtorDaysByPersonResponsibleChart: 'bars',
    DueDatesByPersonChart: 'bars',
    DueDatesOverviewChart: 'bars',
    EnquiriesByLikelihoodToProceedChart: 'pie',
    EnquiriesByQualityChart: 'pie',
    EnquiryActivityByPeriodChart: 'columns',
    EnquiryActivityByUserChart: 'bars',
    EstimatePerformanceChart: 'bars',
    ExpectedFutureFeesByActingChart: 'bars',
    ExpectedFutureFeesByMatterCategoryAndTypeChart: 'bars',
    ExpectedFutureFeesByMatterCategoryChart: 'bars',
    ExpectedFutureFeesByMatterTypeChart: 'bars',
    ExpectedFutureFeesByPropertyChart: 'bars',
    ExpectedFutureFeesByResponsibleChart: 'bars',
    FeesBilledByPeriodChart: 'columns',
    FeesBilledByPeriodVsBudgetChart: 'columns',
    FeesBilledChart: 'columns',
    FeesBilledCumulativeChart: 'columns',
    FeesBilledCumulativeVsBudgetChart: 'columns',
    FeesBilledForMonthChart: 'columns',
    FeesBilledInLast12MonthsChart: 'columns',
    FeesBilledInLastFinancialYearChart: 'columns',
    FeesBilledInLastYearByActingChart: 'bars',
    FeesBilledInLastYearByMatterCategoryChart: 'bars',
    FeesBilledInLastYearByMatterTypeChart: 'bars',
    FeesBilledInLastYearByPropertyTypeChart: 'bars',
    FeesBilledInLastYearByReportingGroupChart: 'bars',
    FeesBilledInLastYearByResponsibleChart: 'bars',
    FeesBilledInPast14DaysChart: 'columns',
    FeesBilledMonthToDateByActingChart: 'bars',
    FeesBilledMonthToDateByMatterCategoryChart: 'bars',
    FeesBilledMonthToDateByMatterTypeChart: 'bars',
    FeesBilledMonthToDateByPropertyTypeChart: 'bars',
    FeesBilledMonthToDateByReportingGroupChart: 'bars',
    FeesBilledMonthToDateByResponsibleChart: 'bars',
    FeesBilledVsBudgetByDepartmentChart: 'bars',
    FeesBilledVsBudgetByFeeEarnerChart: 'bars',
    FeesBilledVsBudgetByOfficeChart: 'bars',
    FeesBilledVsBudgetByTeamChart: 'bars',
    FeesBilledVsBudgetChart: 'columns',
    FeesBilledVsBudgetSpeedometerChart: 'gauge',
    FeesCollectedByPeriodChart: 'columns',
    FeesCollectedByPeriodVsBudgetChart: 'columns',
    FeesCollectedChart: 'columns',
    FeesCollectedCumulativeChart: 'columns',
    FeesCollectedCumulativeVsBudgetChart: 'columns',
    FeesCollectedVsBudgetChart: 'columns',
    FeesCollectedVsBudgetSpeedometerChart: 'gauge',
    FeesRecordedVsBudgetByFeeEarnerChart: 'bars',
    FeesRecordedVsBudgetSpeedometerChart: 'gauge',
    FinancialYearBudgetForecastChart: 'columns',
    ForecastFeesBilledByCategoryChart: 'bars',
    ForecastFeesBilledChart: 'columns',
    ForecastFeesCollectedByCategoryChart: 'bars',
    ForecastFeesCollectedChart: 'columns',
    ForecastHoursByCategoryChart: 'bars',
    ForecastHoursChart: 'columns',
    FutureFeesChart: 'columns',
    FutureSettlementsByPriceChart: 'columns',
    FutureSettlementsChart: 'columns',
    HoursRecordedByStaffMembersChart: 'bars',
    InvoicesInDraftByActingChart: 'bars',
    InvoicesInDraftByMatterCategoryChart: 'bars',
    InvoicesInDraftByMatterTypeChart: 'bars',
    InvoicesInDraftByPropertyTypeChart: 'bars',
    InvoicesInDraftByReportingGroupChart: 'bars',
    InvoicesInDraftByResponsibleChart: 'bars',
    MatterActivityChart: 'bars',
    MatterBillingChart: 'bars',
    MatterCountByActingChart: 'bars',
    MatterCountByMatterCategoryAndTypeChart: 'bars',
    MatterCountByMatterCategoryChart: 'bars',
    MatterCountByMatterTypeChart: 'bars',
    MatterCountByPropertyChart: 'bars',
    MatterCountByReportingGroupChart: 'bars',
    MatterCountByResponsibleChart: 'bars',
    MatterDurationByCategoryOrTypeChart: 'bars',
    MatterFeesVsEstimateChart: 'bars',
    MatterLeadsOpenedLastTwelveMonths: 'line',
    MatterProfitabilityByCategoryChart: 'bars',
    MatterProfitabilityByClientChart: 'bars',
    MatterProfitabilityByMatterTypeChart: 'bars',
    MatterProfitabilityByPersonActingChart: 'bars',
    MatterProfitabilityByPersonResponsibleChart: 'bars',
    MattersByPeriod3ByActingChart: 'bars',
    MattersByPeriod3ByMatterCategoryAndTypeChart: 'bars',
    MattersByPeriod3ByMatterCategoryChart: 'bars',
    MattersByPeriod3ByMatterTypeChart: 'bars',
    MattersByPeriod3ByPropertyChart: 'bars',
    MattersByPeriod3ByResponsibleChart: 'bars',
    MattersByPeriod7ByActingChart: 'bars',
    MattersByPeriod7ByMatterCategoryAndTypeChart: 'bars',
    MattersByPeriod7ByMatterCategoryChart: 'bars',
    MattersByPeriod7ByMatterTypeChart: 'bars',
    MattersByPeriod7ByPropertyChart: 'bars',
    MattersByPeriod7ByResponsibleChart: 'bars',
    MattersByPeriodByActingChart: 'bars',
    MattersByPeriodByMatterCategoryAndTypeChart: 'bars',
    MattersByPeriodByMatterCategoryChart: 'bars',
    MattersByPeriodByMatterTypeChart: 'bars',
    MattersByPeriodByPropertyChart: 'bars',
    MattersByPeriodByResponsibleChart: 'bars',
    MattersByStatusChart: 'pie',
    MattersOpenedChart: 'line',
    MattersVsAverageChart: 'columns',
    MattersWithoutTrustByActingChart: 'bars',
    MattersWithoutTrustByMatterCategoryAndTypeChart: 'bars',
    MattersWithoutTrustByMatterCategoryChart: 'bars',
    MattersWithoutTrustByMatterTypeChart: 'bars',
    MattersWithoutTrustByPropertyChart: 'bars',
    MattersWithoutTrustByResponsibleChart: 'bars',
    NewLeadsInLast7DaysByAreaOfLaw: 'bars',
    NewLeadsInLast7DaysBySource: 'bars',
    NewMatterLeadsInLastTwelveMonthsByActingChart: 'bars',
    NewMatterLeadsInLastTwelveMonthsByMatterCategoryAndTypeChart: 'bars',
    NewMatterLeadsInLastTwelveMonthsByMatterCategoryChart: 'bars',
    NewMatterLeadsInLastTwelveMonthsByMatterTypeChart: 'bars',
    NewMatterLeadsInLastTwelveMonthsByResponsibleChart: 'bars',
    NewMatterLeadsVsThreeYearAverageChart: 'columns',
    NewMattersByPeriodChart: 'bars',
    NewMattersInLastTwelveMonthsByActingChart: 'bars',
    NewMattersInLastTwelveMonthsByMatterCategoryAndTypeChart: 'bars',
    NewMattersInLastTwelveMonthsByMatterCategoryChart: 'bars',
    NewMattersInLastTwelveMonthsByMatterTypeChart: 'bars',
    NewMattersInLastTwelveMonthsByPropertyChart: 'bars',
    NewMattersInLastTwelveMonthsByReportingGroupChart: 'bars',
    NewMattersInLastTwelveMonthsByResponsibleChart: 'bars',
    NonBillableTimesByActivityChart: 'bars',
    NonBillableTimesByStaffChart: 'bars',
    PhoneCallResponseTimeChart: 'bars',
    PipelineVsMatterActivityChart: 'columns',
    SalesPipelineByAreaOfLawChart: 'bars',
    SalesPipelineByAssigneeChart: 'bars',
    SalesPipelineByLocationChart: 'bars',
    TaskQueueByAssigneeChart: 'bars',
    TaskQueueByCreationTimeChart: 'columns',
    TaskQueueByPriorityChart: 'bars',
    TaskQueueByTaskTypeDescriptionChart: 'bars',
    TaskResponseTimeByAssignee: 'bars',
    TaskResponseTimeByTaskType: 'bars',
    TimesheetFeesInFinancialYearAggregateChart: 'columns',
    TimesheetFeesInFinancialYearChart: 'columns',
    TimesheetFeesInLastPeriodsChart: 'columns',
    TimesheetFeesWithBudgetInFinancialYearAggregateChart: 'columns',
    TimesheetFeesWithBudgetInFinancialYearChart: 'columns',
    TimesheetFeesWithBudgetInLastPeriodsChart: 'columns',
    TimesheetTimeAndFeesInLastPeriodsChart: 'columns',
    TimesheetTimeInFinancialYearAggregateChart: 'columns',
    TimesheetTimeInFinancialYearChart: 'columns',
    TimesheetTimeInLastPeriodsChart: 'columns',
    TimesheetTimeWithBudgetInFinancialYearAggregateChart: 'columns',
    TimesheetTimeWithBudgetInFinancialYearChart: 'columns',
    TimesheetTimeWithBudgetInLastPeriodsChart: 'columns',
    TopReferrersInLast12MonthsChart: 'bars',
    TopReferrersInLastNinetyDaysChart: 'bars',
    TopReferrersInLastThirtyDaysChart: 'bars',
    TotalDebtOwingPieChart: 'pie',
    TotalOwingChart: 'bars',
    TrustBalanceChart: 'bars',
    TrustBalancesByAgeChart: 'bars',
    TrustFundsAvailableChart: 'bars',
    UnbilledDisbursementsByActingChart: 'bars',
    UnbilledDisbursementsByMatterCategoryAndTypeChart: 'bars',
    UnbilledDisbursementsByMatterCategoryChart: 'bars',
    UnbilledDisbursementsByMatterTypeChart: 'bars',
    UnbilledDisbursementsByPropertyChart: 'bars',
    UnbilledDisbursementsByResponsibleChart: 'bars',
    UnbilledFeesByActingChart: 'bars',
    UnbilledFeesByMatterCategoryAndTypeChart: 'bars',
    UnbilledFeesByMatterCategoryChart: 'bars',
    UnbilledFeesByMatterTypeChart: 'bars',
    UnbilledFeesByPropertyChart: 'bars',
    UnbilledFeesByResponsibleChart: 'bars',
    WIPLockUpDaysByMatterCategoryChart: 'bars',
    WIPLockUpDaysByMatterTypeChart: 'bars',
    WIPLockUpDaysByPersonActingChart: 'bars',
    WIPLockUpDaysByPersonResponsibleChart: 'bars',
    YearBudgetsChart: 'columns',
};

export const getChartSkeleton = (featureName: string): ChartSkeletonVariant => CHART_SKELETON_BY_FEATURE[featureName] || 'card';

const REMEMBERED_LAYOUT_PREFIX = 'rv-dashboard-layout:';
// how many cards the first-load skeleton grid shows (two rows of the widest layout)
const INITIAL_SKELETON_COUNT = 8;

const getRememberedLayoutKey = (layoutId: number, dashboardPanelValue: string | number | undefined) =>
    `${REMEMBERED_LAYOUT_PREFIX}${layoutId}:${dashboardPanelValue === undefined ? 'all' : dashboardPanelValue}`;

// The dashboard's layout is only known once its query has answered, so the very first skeleton grid cannot know which chart is where. Remembering the
// last layout of this dashboard and panel lets every later visit start with the right skeletons straight away. Display only: nothing here
// changes which charts are shown.
export const rememberDashboardLayout = (layoutId: number, dashboardPanelValue: string | number | undefined, featureNames: string[]) => {
    try {
        window.localStorage.setItem(getRememberedLayoutKey(layoutId, dashboardPanelValue), JSON.stringify(featureNames.slice(0, INITIAL_SKELETON_COUNT * 2)));
    } catch (error) {
        // storage can be unavailable (private window, blocked site data); the skeletons are then the neutral card
    }
};

export const getInitialSkeletonVariants = (layoutId: number, dashboardPanelValue: string | number | undefined): ChartSkeletonVariant[] => {
    try {
        const stored = window.localStorage.getItem(getRememberedLayoutKey(layoutId, dashboardPanelValue));
        const featureNames: unknown = stored ? JSON.parse(stored) : null;
        if (Array.isArray(featureNames) && featureNames.length > 0) {
            return featureNames.slice(0, INITIAL_SKELETON_COUNT).map((featureName) => getChartSkeleton(String(featureName)));
        }
    } catch (error) {
        // fall through to the neutral cards
    }
    return new Array<ChartSkeletonVariant>(INITIAL_SKELETON_COUNT).fill('card');
};
